// @ts-ignore
import type * as SchemaTypes from '../../../index';

import { gql } from 'graphql-tag';
import { AddToCartReadyToGoRingSuccessNewCustomerFragmentDoc } from './success/addToCartReadyToGoRingSuccessNewCustomer.fragment.generated';
export const AddToCartReadyToGoRingNewCustomerResponseFragmentDoc = gql`
    fragment addToCartReadyToGoRingNewCustomerResponse on AddToCartReadyToGoRingNewCustomerResponse {
  ...addToCartReadyToGoRingSuccessNewCustomer
}
    ${AddToCartReadyToGoRingSuccessNewCustomerFragmentDoc}`;